import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  BackButton,
  Balance,
  BalanceContainer,
  Card,
  CardHeader,
  CardHeaderColumn,
  CardHeaderSubtitle,
  CardHeaderTitle,
  Cards,
  CardText,
  CardTextRow,
  Container,
  FooterText,
  Pagination,
  PaginationButton,
  PaginationCurrent,
  Row,
  SectionHeader,
  SectionTitle,
  SmallTitle,
  SmallTitleRow,
  Table,
  TableCell,
  TableContainer,
  TableFooter,
  TableHeader,
  TableLoading,
  TableRow,
  TextContainer,
  Title,
  FooterActions,
  BalanceSection,
  MobileTextContainer,
  EmptyState,
  LoginButton,
  NoWrapText,
  Relative,
  Tooltip,
  DescriptionText,
  Description,
  TitleContainer,
  TitleRow,
  Link,
  SmallRow,
} from "./WalletPage.styles";

import Button from "../../components/utils/Button/Button";
import MainContainer from "../../components/MainContainer";

// import { ReactComponent as StarSvg } from "../../assets/icons/gradientStarSvg.svg";
import { ReactComponent as WhiteStarSvg } from "../../assets/icons/whiteStar.svg";
import { ReactComponent as UsersSvg } from "../../assets/icons/users.svg";
import { ReactComponent as InfoSvg } from "../../assets/icons/info-circle.svg";
import { ReactComponent as CoinsSvg } from "../../assets/icons/coins.svg";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevronLeft.svg";

import { formatDate, priceFormatterDecimal } from "../../utils/utils";
import RequestWithdrawalModal from "../../components/RequestWithdrawalModal/RequestWithdrawalModal";
import { useDispatch, useSelector } from "react-redux";
import { selectRequestWithdrawal } from "../../store/slices/payment/slice";
import { fetchRequestWithdrawal } from "../../store/slices/payment/asyncThunk";
import { selectUser } from "../../store/slices/user/slice";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import { setSignUpModalOpen } from "../../store/slices/common/slice";
import TextModal from "../../components/TextModal/TextModal";
import { toast } from "sonner";
// import GradientBarChart from "../../components/GradientBarChart/GradientBarChart";

const HeaderComponent = ({
  wallet,
  openModal,
  setShowTooltip,
  showTooltip,
  show,
  setShowLearnMoreModal,
  navigate,
  user,
}) => {
  const calculatePrice = (templateCredits, referralCredits) => {
    const oneDollarToTemplateCredit = 1 / 150;
    const oneDollarToReferralCredit = 1 / 50;

    return (
      templateCredits * oneDollarToTemplateCredit +
      referralCredits * oneDollarToReferralCredit
    ).toFixed(2);
  };

  const availableReferralCredits = parseInt(
    wallet?.referralBalance?.available ?? 0,
  );
  const availableTemplateCredits = parseInt(
    wallet?.templateBalance?.available ?? 0,
  );

  const referralLink = user?.affiliateLink;

  const handleShare = async () => {
    const shareData = {
      title: "Join Playbun - NSFW AI Video Generation",
      text: "Create amazing NSFW AI videos with Playbun! Use my referral link to get started.",
      url: referralLink,
    };

    try {
      // Check if Web Share API is supported (mainly on mobile)
      if (navigator.share) {
        await navigator.share(shareData);
        toast.success("Invite shared successfully!");
      } else {
        // Fallback: Copy to clipboard if Web Share API is not supported
        await navigator.clipboard.writeText(
          `${shareData.text} ${shareData.url}`,
        );
        toast.success("Invite message copied to clipboard!");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        // User didn't cancel the share
        console.error("Error sharing:", err);
        toast.error("Failed to share invite. Please try again.");
      }
    }
  };

  return (
    <>
      <TextContainer>
        {show ? (
          <TitleContainer>
            <SmallRow>
              <Title>Wallet</Title>
              <InfoSvg
                style={{ cursor: "pointer" }}
                width={18}
                height={18}
                onClick={() => {
                  setShowLearnMoreModal(true);
                }}
              />
            </SmallRow>
          </TitleContainer>
        ) : (
          <TitleContainer>
            <Title>Wallet</Title>
            <Description>
              The Wallet serves to pay out Creators of Templates and Affiliate
              users who refer subscribers to Playbun. Once you start generating
              templates in the Train section or refer subscribers through your
              Affiliate link, you will start seeing wallet credits which can be
              withdrawn in USDT. <br />
              Wallet amounts are refreshed periodically on a daily basis.
              Credits move from pending to available 14 days after they are
              earned.
            </Description>
            <TitleRow>
              <Link
                onClick={() => {
                  navigate("/referral/earnings");
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }}
              >
                Invite Friends
              </Link>
              <Link
                onClick={() => {
                  navigate("/train");
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }}
              >
                Train your own Templates
              </Link>
            </TitleRow>
          </TitleContainer>
        )}
        <SmallTitleRow>
          <div style={{ display: "flex", gap: 5 }}>
            <SmallTitle>Available Balance</SmallTitle>

            <Relative
              onMouseEnter={() => {
                setShowTooltip(true);
              }}
              onMouseLeave={() => {
                setShowTooltip(false);
              }}
            >
              <Tooltip $show={showTooltip}>
                Wallet amounts are refreshed periodically on a daily basis.
              </Tooltip>
              <InfoSvg width={18} height={18} />
            </Relative>
          </div>
          {show && (
            <Button
              title={"Request Withdrawal"}
              textColor="white"
              onClick={openModal}
              background="linear-gradient(180deg, var(--100, #4D9DFF) 0%, var(--200, #2877D9) 100%)"
            />
          )}
        </SmallTitleRow>
        <BalanceContainer>
          <Balance>
            {`$ ${calculatePrice(availableTemplateCredits, availableReferralCredits)}`}
          </Balance>
        </BalanceContainer>
      </TextContainer>

      <MobileTextContainer>
        {show ? (
          <TitleContainer>
            <SmallRow>
              <Title>Wallet</Title>

              <InfoSvg
                style={{ cursor: "pointer" }}
                width={18}
                height={18}
                onClick={() => {
                  setShowLearnMoreModal(true);
                }}
              />
            </SmallRow>
          </TitleContainer>
        ) : (
          <TitleContainer>
            <Title>Wallet</Title>
            <Description>
              The Wallet serves to pay out Creators of Templates and Affiliate
              users who refer subscribers to Playbun. Once you start generating
              templates in the Train section or refer subscribers through your
              Affiliate link, you will start seeing wallet credits which can be
              withdrawn in USDT.
              <br />
              Wallet amounts are refreshed periodically on a daily basis.
              Credits move from pending to available 14 days after they are
              earned.
            </Description>
            <TitleRow>
              <Link onClick={handleShare}>Invite Friends</Link>
              <Link
                onClick={() => {
                  navigate("/train");
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }}
              >
                Train your own Templates
              </Link>
            </TitleRow>
          </TitleContainer>
        )}

        <SmallTitleRow>
          <SmallTitle>Available Balance</SmallTitle>
          <BalanceContainer>
            <Row>
              <Balance>
                ${" "}
                {calculatePrice(
                  availableTemplateCredits,
                  availableReferralCredits,
                )}
              </Balance>
            </Row>
          </BalanceContainer>
        </SmallTitleRow>
        {show && (
          <Button
            title={"Request Withdrawal"}
            textColor="white"
            onClick={openModal}
            background="linear-gradient(180deg, var(--100, #4D9DFF) 0%, var(--200, #2877D9) 100%)"
          />
        )}
      </MobileTextContainer>
    </>
  );
};

const WalletPage = () => {
  const navigate = useNavigate();
  const [isBalanceExpanded, setIsBalanceExpanded] = useState(true);
  const [withdrawalOpen, setWithdrawalOpen] = useState(false);
  const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);
  const requestWithdrawalData = useSelector(selectRequestWithdrawal);
  // const [chartData, setChartData] = useState([]);

  const user = useSelector(selectUser);
  const isLoggedIn = useSelector(selectLoggedIn);

  const creditsHistoryPage = requestWithdrawalData.page;
  const creditsHistoryTotal = requestWithdrawalData.total;
  const creditsHistoryPerPage = 10;

  const [showTooltip, setShowTooltip] = useState(false);

  const handlePageChange = (nextPage) => {
    dispatch(fetchRequestWithdrawal({ nextPage }));
  };

  const hasEarnedCredits =
    parseInt(user?.wallet?.referralBalance?.lifetime ?? 0) > 0 ||
    parseInt(user?.wallet?.templateBalance?.lifetime ?? 0) > 0;

  const handleBack = () => {
    navigate("/");
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }, 300);
  };

  const toggleBalance = () => {
    setIsBalanceExpanded(!isBalanceExpanded);
  };

  const openModal = () => {
    setWithdrawalOpen(true);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchRequestWithdrawal());
    }
  }, [dispatch, isLoggedIn]);

  if (isLoggedIn === null) {
    return null;
  }

  if (isLoggedIn === false) {
    return (
      <MainContainer>
        <EmptyState>
          <h3>Login Required</h3>
          <p>You need to be logged in to view training models.</p>
          <LoginButton
            onClick={() => {
              dispatch(setSignUpModalOpen(true));
            }}
          >
            Login
          </LoginButton>
        </EmptyState>
      </MainContainer>
    );
  }

  return (
    <MainContainer>
      <Container>
        <BackButton onClick={handleBack}>
          <ChevronSvg />
          Back
        </BackButton>

        <HeaderComponent
          wallet={user?.wallet}
          openModal={openModal}
          show={hasEarnedCredits}
          showTooltip={showTooltip}
          setShowTooltip={setShowTooltip}
          setShowLearnMoreModal={setShowLearnMoreModal}
          navigate={navigate}
          user={user}
        />

        <Cards>
          <Card>
            <CardHeader>
              <CardHeaderColumn>
                <CardHeaderTitle>Referral Balance</CardHeaderTitle>
                <CardHeaderSubtitle>
                  <NoWrapText> Earned from users you invited </NoWrapText>
                  <NoWrapText>
                    50
                    <WhiteStarSvg
                      width={14}
                      height={14}
                      style={{ marginBottom: -1, marginLeft: 2 }}
                    />{" "}
                    : 1$
                  </NoWrapText>
                </CardHeaderSubtitle>
              </CardHeaderColumn>
              <UsersSvg height={24} width={24} />
            </CardHeader>
            <CardTextRow>
              <CardText>Available</CardText>
              <Row>
                <CardText>
                  {parseInt(
                    user?.wallet?.referralBalance?.available ?? 0,
                  )?.toLocaleString("en-US")}
                </CardText>
                <WhiteStarSvg />
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <Row>
                <CardText $light>Pending</CardText>
              </Row>
              <Row>
                <CardText $light>
                  {parseInt(
                    user?.wallet?.referralBalance?.pending ?? 0,
                  )?.toLocaleString("en-US")}
                </CardText>
                <WhiteStarSvg />
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <CardText $light>Lifetime</CardText>
              <Row>
                <CardText $light>
                  {parseInt(
                    user?.wallet?.referralBalance?.lifetime ?? 0,
                  )?.toLocaleString("en-US")}
                </CardText>
                <WhiteStarSvg />
              </Row>
            </CardTextRow>
          </Card>

          <Card>
            <CardHeader>
              <CardHeaderColumn>
                <CardHeaderTitle>Template Balance </CardHeaderTitle>
                <CardHeaderSubtitle>
                  <NoWrapText>Earned from template sales</NoWrapText>
                  <NoWrapText>
                    150
                    <WhiteStarSvg
                      width={14}
                      height={14}
                      style={{ marginBottom: -1, marginLeft: 2 }}
                    />{" "}
                    : 1$
                  </NoWrapText>
                </CardHeaderSubtitle>
              </CardHeaderColumn>
              <CoinsSvg height={24} width={24} />
            </CardHeader>
            <CardTextRow>
              <CardText>Available</CardText>
              <Row>
                <CardText>
                  {parseInt(
                    user?.wallet?.templateBalance?.available ?? 0,
                  )?.toLocaleString("en-US")}
                </CardText>
                <WhiteStarSvg />
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <Row>
                <CardText $light>Pending</CardText>
                {/* <Relative
                  onMouseEnter={() => {
                    setHoveredPendingTemplate(true);
                  }}
                  onMouseLeave={() => {
                    setHoveredPendingTemplate(false);
                  }}
                >
                  <Tooltip $show={hoveredPendingTemplate}>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                  </Tooltip>
                  <InfoSvg width={18} height={18} />
                </Relative> */}
              </Row>
              <Row>
                <CardText $light>
                  {parseInt(
                    user?.wallet?.templateBalance?.pending ?? 0,
                  )?.toLocaleString("en-US")}
                </CardText>
                <WhiteStarSvg />
              </Row>
            </CardTextRow>
            <CardTextRow $light>
              <CardText $light>Lifetime</CardText>
              <Row>
                <CardText $light>
                  {parseInt(
                    user?.wallet?.templateBalance?.lifetime ?? 0,
                  )?.toLocaleString("en-US")}
                </CardText>
                <WhiteStarSvg />
              </Row>
            </CardTextRow>
          </Card>
        </Cards>
        {hasEarnedCredits && (
          <BalanceSection>
            <SectionHeader onClick={toggleBalance}>
              <SectionTitle>History</SectionTitle>
              <ChevronSvg
                size={14}
                style={{
                  transition: "transform 0.3s ease-in-out",
                  transform: isBalanceExpanded
                    ? "rotate(90deg)"
                    : "rotate(-90deg)",
                  cursor: "pointer",
                  opacity: 0.7,
                }}
              />
            </SectionHeader>
            <TableContainer $isExpanded={isBalanceExpanded}>
              <Table>
                <thead>
                  <TableRow>
                    <TableHeader>Description</TableHeader>
                    <TableHeader>Date</TableHeader>
                    <TableHeader>Amount</TableHeader>
                    <TableHeader>Status</TableHeader>
                  </TableRow>
                </thead>
                <tbody>
                  {requestWithdrawalData.loading ? (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        style={{ textAlign: "center", height: 100 }}
                      >
                        <TableLoading>
                          <l-line-spinner
                            size="24"
                            stroke="2"
                            speed="1.5"
                            color="#fff"
                          />
                          <span>Loading transaction history...</span>
                        </TableLoading>
                      </TableCell>
                    </TableRow>
                  ) : requestWithdrawalData.data.length === 0 ||
                    !requestWithdrawalData.data ? (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        style={{
                          textAlign: "center",
                          height: 100,
                          textTransform: "unset",
                        }}
                      >
                        <TableLoading>
                          <span>You have no transactions yet.</span>
                        </TableLoading>
                      </TableCell>
                    </TableRow>
                  ) : (
                    requestWithdrawalData.data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell $isFirst={true} style={{ color: "#fff" }}>
                          Request Withdrawal
                        </TableCell>
                        <TableCell style={{ color: "#fff" }}>
                          {formatDate(item?.createdAt)}
                        </TableCell>

                        <TableCell style={{ color: "#fff" }}>
                          <Row>${priceFormatterDecimal(item?.amount)}</Row>
                        </TableCell>

                        <TableCell style={{ color: "#fff" }}>
                          {item?.status}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </tbody>
              </Table>

              <TableFooter>
                <FooterActions>
                  <FooterText>
                    Showing {requestWithdrawalData.data.length} of{" "}
                    {creditsHistoryTotal} grants
                  </FooterText>
                </FooterActions>
                <FooterActions>
                  <Pagination>
                    <PaginationButton
                      disabled={creditsHistoryPage <= 1}
                      onClick={() => handlePageChange(creditsHistoryPage - 1)}
                    >
                      Previous
                    </PaginationButton>

                    <PaginationCurrent>
                      Page {creditsHistoryPage} of{" "}
                      {Math.ceil(creditsHistoryTotal / creditsHistoryPerPage)}
                    </PaginationCurrent>

                    <PaginationButton
                      disabled={
                        creditsHistoryPage >=
                        Math.ceil(creditsHistoryTotal / creditsHistoryPerPage)
                      }
                      onClick={() => handlePageChange(creditsHistoryPage + 1)}
                    >
                      Next
                    </PaginationButton>
                  </Pagination>
                </FooterActions>
              </TableFooter>
            </TableContainer>
          </BalanceSection>
        )}

        {/* <BalanceSection>
          <GradientBarChart data={chartData} />
        </BalanceSection> */}
        {hasEarnedCredits && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <DescriptionText>
              Rewards are determined based on a comprehensive evaluation of
              template usage, quality, and diversity.
            </DescriptionText>

            <DescriptionText>
              When your template is used publicly, credits are earned based on
              how long the template has been published: 2 credits per generation
              during the first 30 days, 2 credits per generation from days
              31-60, and 1 credit per generation after 60 days.
            </DescriptionText>

            <DescriptionText>
              Withdrawals are supported only in USDT on the Solana network.
              Eligibility: ≥ 100 UST per withdrawal.
            </DescriptionText>
          </div>
        )}
      </Container>
      <RequestWithdrawalModal
        isOpen={withdrawalOpen}
        onClose={() => {
          setWithdrawalOpen(false);
        }}
      />
      <TextModal
        isOpen={showLearnMoreModal}
        hideButtons
        title={"💳 The Wallet"}
        message={
          "The Wallet serves to pay out Creators of Templates and Affiliate users who refer subscribers to Playbun. Once you start generating templates in the Train section or refer subscribers through your Affiliate link, you will start seeing wallet credits which can be withdrawn in USDT. \nWallet amounts are refreshed periodically on a daily basis. Credits move from pending to available 14 days after they are earned."
        }
        onClose={() => {
          setShowLearnMoreModal(false);
        }}
      />
    </MainContainer>
  );
};

export default WalletPage;
